export default {
  getLocale: state => state.locale,
  getLocales: state => state.locales,
}
